import React from 'react';
import { Settings } from 'lucide-react';

const GeneralSettingsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">General Settings</h1>
        <p className="text-slate-400 mt-1">System configuration and company details</p>
      </div>
      <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl p-12 text-center">
        <Settings className="w-16 h-16 text-orange-500/50 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-slate-300 mb-2">Coming Soon</h2>
        <p className="text-slate-500 max-w-md mx-auto">
          This feature is under development and will be available in a future update.
        </p>
      </div>
    </div>
  );
};

export default GeneralSettingsPage;
